import { useCallback, useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Loader2, Zap } from "lucide-react";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Button } from "@/components/ui/button";
import PageHeader from "@/components/PageHeader";
import QueueItem from "@/components/QueueItem";
import ClearQueueButton from "@/components/ClearQueueButton";
import BackgroundModeCard from "@/components/BackgroundModeCard";
import api from "@/lib/api";

export default function Queue() {
  const location = useLocation();
  const [bucket, setBucket] = useState(location.state?.bucket || "due");
  const [items, setItems] = useState(null);

  const load = useCallback(async () => {
    const { data } = await api.get("/queue", { params: { bucket } });
    setItems(data);
  }, [bucket]);

  useEffect(() => {
    setItems(null);
    load().catch(() => setItems([]));
    const t = setInterval(() => load().catch(() => {}), 30000);
    return () => clearInterval(t);
  }, [load]);

  return (
    <div>
      <PageHeader
        eyebrow="Jadual & Giliran"
        title="Giliran post"
        desc="Untuk group: tekan “Salin & Buka Group”, tampal teks dalam Facebook, kemudian tanda selesai. Post untuk Facebook Page dihantar secara automatik."
        action={<Button asChild data-testid="queue-fast-post-btn"><Link to="/post-pantas"><Zap className="mr-2 h-4 w-4" /> Mula Mod Post Pantas</Link></Button>}
      />
      <BackgroundModeCard />
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <Tabs value={bucket} onValueChange={setBucket}>
          <TabsList className="h-auto flex-wrap bg-card">
            <TabsTrigger value="due" data-testid="queue-tab-due">Perlu Dipost Sekarang</TabsTrigger>
            <TabsTrigger value="upcoming" data-testid="queue-tab-upcoming">Akan Datang</TabsTrigger>
            <TabsTrigger value="approval" data-testid="queue-tab-approval">Menunggu Admin</TabsTrigger>
          </TabsList>
        </Tabs>
        <ClearQueueButton bucket={bucket} count={items?.length || 0} onCleared={() => load().catch(() => {})} />
      </div>
      <div className="mt-6 grid gap-4 lg:grid-cols-2" data-testid="queue-list">
        {items === null && <Loader2 className="h-5 w-5 animate-spin text-primary" />}
        {items?.length === 0 && (
          <div className="panel col-span-full p-12 text-center" data-testid="queue-empty">
            <p className="text-sm text-muted-foreground">{bucket === "due" ? "Tiada post yang perlu dibuat sekarang." : bucket === "approval" ? "Tiada post menunggu kelulusan admin." : "Tiada post terjadual."}</p>
            <Button asChild variant="secondary" className="mt-4"><Link to="/tulis">Tulis post baharu</Link></Button>
          </div>
        )}
        {items?.map((item, i) => <QueueItem key={item.tid} item={item} due={bucket === "due"} index={i} onChange={load} />)}
      </div>
    </div>
  );
}
